import type { Stripe } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";

let stripePromise: Promise<Stripe | null> | undefined;

/**
 * Loads and caches Stripe.js when enabled and configured. Resolves `null` when
 * disabled or missing a publishable key; a rejected load clears the cache so
 * the next call can retry.
 */
export function getStripe(): Promise<Stripe | null> {
  const { STRIPE_ENABLED, STRIPE_PUBLISHABLE_KEY } = window.env;

  if (!STRIPE_ENABLED || !STRIPE_PUBLISHABLE_KEY) {
    return Promise.resolve(null);
  }

  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
    const pendingStripe = stripePromise;

    void pendingStripe.catch(() => {
      if (stripePromise === pendingStripe) {
        stripePromise = undefined;
      }
    });
  }

  return stripePromise;
}

/** Clears the cached Stripe.js load between isolated tests. */
export function resetStripeForTests(): void {
  stripePromise = undefined;
}
